// extracted by mini-css-extract-plugin
export default {"title":"GroupUserCard-module__title--qYDlB","name":"GroupUserCard-module__name--uUL_c","animatedBackground":"GroupUserCard-module__animatedBackground--lB56n"};